import { render, staticRenderFns } from "./ConfirmacaoDeUsoPaciente.vue?vue&type=template&id=3c176a0c&"
import script from "./ConfirmacaoDeUsoPaciente.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoDeUsoPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports